const images = {
  logo: require("../assets/LOGO-06.png"),
  product: require("../assets/images.jpeg"),
  product1: require("../assets/example.jpeg"),
  product2: require("../assets/example1.jpg"),
  vis: require("../assets/vis.png"),
  mastercard: require("../assets/mastercard.png"),
};
export default images;
